var render = function () {
  var _vm$detail$refundingT, _vm$detail$refundingT2, _vm$detail$customerIn, _vm$detail$customerIn3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "desp"
  }, [_c('div', {
    staticClass: "desp-header"
  }, [_vm._v("Refund Information")]), _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Apply Reason")]), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self danger"
  }, [_vm._v(_vm._s(_vm.detail.applyReason || ""))])])]), _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Amount")]), _c('div', {
    staticClass: "desp-items-wrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "lh18 desp-item-label"
  }, [_c('span', {
    staticClass: "mr8"
  }, [_vm._v("Total Due")]), _c('br'), _c('span', {
    staticClass: "fs12"
  }, [_vm._v("(Excl. Tax)")])]), _c('div', {
    staticClass: "lh18 desp-item-content"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v(" " + _vm._s(_vm.currencyAndAmountFormat(_vm.detail.billingCurrency, _vm.detail.refundAmountExclTax)) + " ")]), _c('br'), _vm.$isNumberLike(_vm.detail.refundAmountCnyExclTax) ? _c('span', [_vm._v(_vm._s(_vm.symbolAndAmountFormat("¥", _vm.detail.refundAmountCnyExclTax)))]) : _vm._e()])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Gov Fee")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v(" " + _vm._s(_vm.currencyAndAmountFormat(_vm.detail.billingCurrency, _vm.detail.deductionAcraFee)) + " ")])])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Handling Fee")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v(" " + _vm._s(_vm.currencyAndAmountFormat(_vm.detail.billingCurrency, _vm.detail.deductionHandlingFee)) + " ")])])])])], 1)], 1)]), _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Information")]), _c('div', {
    staticClass: "desp-items-wrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Transaction No.")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.detail.businessNo))])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Refund Status")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(" " + _vm._s(_vm.refundStatusFormat(_vm.detail.status)) + " ")])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Refund No.")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(" " + _vm._s(_vm.detail.refundNo || "") + " ")])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Create Time")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(_vm._s(_vm.detail.createTime))])])])], 1)], 1)]), _vm.detail.failReason ? _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Fail Reason")]), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self danger"
  }, [_vm._v(_vm._s(_vm.detail.failReason || ""))])])]) : _vm._e(), _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Operator")]), _c('div', {
    staticClass: "desp-items-wrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Refund Teller")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(" " + _vm._s(((_vm$detail$refundingT = _vm.detail.refundingTeller) === null || _vm$detail$refundingT === void 0 ? void 0 : _vm$detail$refundingT.nickname) || ((_vm$detail$refundingT2 = _vm.detail.refundingTeller) === null || _vm$detail$refundingT2 === void 0 ? void 0 : _vm$detail$refundingT2.username) || "") + " ")])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Apply Time")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(" " + _vm._s(_vm.detail.applyTime || "") + " ")])])]), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-label"
  }, [_vm._v("Finish Time")]), _c('div', {
    staticClass: "desp-item-content"
  }, [_vm._v(" " + _vm._s(_vm.detail.finishTime || "") + " ")])])])], 1)], 1)]), _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Generic Invoice")]), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self"
  }, [((_vm$detail$customerIn = _vm.detail.customerInvoice) === null || _vm$detail$customerIn === void 0 ? void 0 : _vm$detail$customerIn.invoiceType) == 1 ? _c('span', {
    staticClass: "mr40 to-link",
    on: {
      "click": function click($event) {
        var _vm$detail$customerIn2;

        return _vm.invoiceLink((_vm$detail$customerIn2 = _vm.detail.customerInvoice) === null || _vm$detail$customerIn2 === void 0 ? void 0 : _vm$detail$customerIn2.invoiceNumber);
      }
    }
  }, [_vm._v(" Invoice ")]) : _vm._e(), ((_vm$detail$customerIn3 = _vm.detail.customerInvoice) === null || _vm$detail$customerIn3 === void 0 ? void 0 : _vm$detail$customerIn3.invoiceType) == 2 ? _c('span', {
    staticClass: "to-link",
    on: {
      "click": function click($event) {
        var _vm$detail$customerIn4;

        return _vm.invoiceLink((_vm$detail$customerIn4 = _vm.detail.customerInvoice) === null || _vm$detail$customerIn4 === void 0 ? void 0 : _vm$detail$customerIn4.invoiceNumber);
      }
    }
  }, [_vm._v(" Credit Invoice ")]) : _vm._e()])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }